import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './ProjectCarousel.module.css';

// Use Cloudinary-hosted images instead of local assets
const cloudinaryUrls = [
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1746977724/Screenshot_2025-05-11_162739_odkn4k.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360946/flink_kylsmc.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360946/Screenshot_2025-10-01_233231_mo7axi.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360946/Screenshot_2025-10-01_233204_xup9zq.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360947/Screenshot_2025-10-01_233241_bvyzuw.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360946/calcium1_cs6r91.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360948/ghulgraft1_o4kzcu.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360948/auto-aucton1_xc9awi.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360948/gog1_iywvcu.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360949/kk1_xzcngt.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360948/katana2_yjy28o.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360949/pulsar1_kfjagi.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360949/video-call_x4opse.png',
	// 'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360949/null_wallet1_lrxerx.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360950/Screenshot_163_xczv6r.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360948/katana_qtiqer.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360950/racing1_hqmxf6.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360950/Screenshot_219_uujell.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360950/Screenshot_2023-11-02_100401_hzgf7h.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360951/Screenshot_2024-02-24_175506_z4eogw.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360951/Screenshot_2024-08-22_152355_hvxq1p.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360951/Screenshot_2025-03-02_205213_zxp1cv.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360951/Screenshot_2024-08-10_142126_ipymh5.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360951/Screenshot_2025-06-24_001647_mwi7pb.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360951/Screenshot_2025-06-22_113446_s2xh1u.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360956/Screenshot_2025-07-01_140956_xsljsl.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360957/Screenshot_2025-10-01_224640_h82uza.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360957/Screenshot_2025-10-01_231136_drlrlr.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360957/Screenshot_2025-10-01_203259_dnmfvi.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360957/Screenshot_2025-10-01_231145_dqrgue.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360958/Screenshot_2025-10-01_233125_o91cfj.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360960/Screenshot_2025-10-01_233146_cobfov.png',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759360961/Screenshot_2025-10-01_233154_nabsnm.png',
	// Added defaults
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759362021/default_1_ishc1k.jpg',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759362021/default_omxiyi.jpg',
	'https://res.cloudinary.com/dcv1yl0u4/image/upload/v1759362021/default_2_mlqive.jpg',
];

// Build images list and shuffle order
const images = (() => {
	const arr = cloudinaryUrls.map((url) => {
		const file = url.split('/').pop() || '';
		const name = file.replace(/\.[^/.]+$/, '').replace(/[_-]+/g, ' ');
		return { src: url, name };
	});
	// Fisher-Yates shuffle
	for (let i = arr.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}
	return arr;
})();

const ProjectCarousel = () => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isAutoPlay, setIsAutoPlay] = useState(true);
	// Always show one project at a time
	const itemsToShow = 1;
	const maxIndex = Math.max(0, images.length - itemsToShow);
	const trackRef = useRef(null);
	const containerRef = useRef(null);
	const startXRef = useRef(0);
	const deltaXRef = useRef(0);
	const isDraggingRef = useRef(false);

	// Items per view fixed to 1, so no responsive adjustment needed

	// Auto-slide functionality
	useEffect(() => {
		if (!isAutoPlay) return;

		const interval = setInterval(() => {
			setCurrentIndex((prevIndex) => 
				prevIndex >= maxIndex ? 0 : prevIndex + 1
			);
		}, 3000); // Change slide every 3 seconds

		return () => clearInterval(interval);
	}, [isAutoPlay, maxIndex]);

	// Pause when tab is hidden
	useEffect(() => {
		const onVis = () => {
			if (document.hidden) setIsAutoPlay(false);
		};
		document.addEventListener('visibilitychange', onVis);
		return () => document.removeEventListener('visibilitychange', onVis);
	}, []);

	const goToPrevious = useCallback(() => {
		setCurrentIndex((prev) => (prev === 0 ? maxIndex : prev - 1));
	}, [maxIndex]);

	const goToNext = useCallback(() => {
		setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
	}, [maxIndex]);

	const handleMouseEnter = () => { setIsAutoPlay(false); };
	const handleMouseLeave = () => { setIsAutoPlay(true); };

	// Drag/Swipe handlers
	const onPointerDown = useCallback((e) => {
		isDraggingRef.current = true;
		startXRef.current = 'touches' in e ? e.touches[0].clientX : e.clientX;
		deltaXRef.current = 0;
		if (containerRef.current && 'pointerId' in e) {
			containerRef.current.setPointerCapture?.(e.pointerId);
		}
		setIsAutoPlay(false);
	}, []);

	const onPointerMove = useCallback((e) => {
		if (!isDraggingRef.current) return;
		const x = 'touches' in e ? e.touches[0].clientX : e.clientX;
		deltaXRef.current = x - startXRef.current;
		if (trackRef.current) {
			const pct = (deltaXRef.current / (containerRef.current?.offsetWidth || 1)) * (100 / itemsToShow);
			trackRef.current.style.transition = 'none';
			trackRef.current.style.transform = `translateX(calc(-${currentIndex * (100 / itemsToShow)}% + ${pct}%))`;
		}
	}, [currentIndex, itemsToShow]);

	const endDrag = useCallback(() => {
		if (!isDraggingRef.current) return;
		isDraggingRef.current = false;
		if (trackRef.current) {
			trackRef.current.style.transition = '';
		}
		const threshold = (containerRef.current?.offsetWidth || 0) * 0.15; // 15%
		if (Math.abs(deltaXRef.current) > threshold) {
			if (deltaXRef.current < 0) {
				goToNext();
			} else {
				goToPrevious();
			}
		} else {
			// snap back
			if (trackRef.current) {
				trackRef.current.style.transform = `translateX(-${currentIndex * (100 / itemsToShow)}%)`;
			}
		}
		setIsAutoPlay(true);
	}, [currentIndex, itemsToShow, goToNext, goToPrevious]);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;
		// Mouse
		el.addEventListener('mousedown', onPointerDown);
		window.addEventListener('mousemove', onPointerMove);
		window.addEventListener('mouseup', endDrag);
		// Touch
		el.addEventListener('touchstart', onPointerDown, { passive: true });
		window.addEventListener('touchmove', onPointerMove, { passive: true });
		window.addEventListener('touchend', endDrag);
		return () => {
			el.removeEventListener('mousedown', onPointerDown);
			window.removeEventListener('mousemove', onPointerMove);
			window.removeEventListener('mouseup', endDrag);
			el.removeEventListener('touchstart', onPointerDown);
			window.removeEventListener('touchmove', onPointerMove);
			window.removeEventListener('touchend', endDrag);
		};
	}, [onPointerDown, onPointerMove, endDrag]);

	// Keyboard navigation
	const onKeyDown = (e) => {
		if (e.key === 'ArrowLeft') goToPrevious();
		if (e.key === 'ArrowRight') goToNext();
	};

	return (
		<section className={style.ProjectCarousel} id='projectCarousel' aria-roledescription="carousel" data-reveal="fade">
			<div className={style.CarouselHeader}>
				<h2 className={style.CarouselTitle} data-reveal="up">Highlights</h2>
			</div>

			<div 
				className={style.CarouselContainer}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				ref={containerRef}
				tabIndex={0}
				aria-label="Project carousel"
				onKeyDown={onKeyDown}
			>
				<button 
					className={`${style.CarouselButton} ${style.PrevButton} hover-pop`}
					onClick={goToPrevious}
					aria-label="Previous project"
				>
					‹
				</button>

				<div 
					className={style.CarouselWrapper}
					style={{
						'--itemsToShow': itemsToShow,
					}}
				>
					<div 
						className={style.CarouselTrack}
						style={{
							transform: `translateX(-${currentIndex * (100 / itemsToShow)}%)`,
						}}
						ref={trackRef}
					>
						{images.map((img, index) => (
							<div key={index} className={style.ProjectSlide}>
								<div className={style.ProjectImageCard}>
									<div className={style.ProjectImageContainer}>
										<img 
											src={img.src}
											alt={img.name}
											className={style.ProjectImage}
											loading="lazy"
										/>
										{/* Overlay and descriptions removed intentionally */}
									</div>
								</div>
							</div>
						))}
						</div>
					</div>

					<button 
						className={`${style.CarouselButton} ${style.NextButton} hover-pop`}
						onClick={goToNext}
						aria-label="Next project"
					>
						›
					</button>
				</div>

			<div className={style.CarouselIndicators} role="tablist" aria-label="Project slides">
				{Array.from({ length: maxIndex + 1 }, (_, index) => (
					<button
						key={index}
						className={`${style.Indicator} ${
							index === currentIndex ? style.IndicatorActive : ''
						}`}
						onClick={() => setCurrentIndex(index)}
						aria-label={`Go to slide ${index + 1}`}
						role="tab"
						aria-selected={index === currentIndex}
					/>
				))}
			</div>

			<div className={style.CarouselControls}>
				<button
					className={`${style.PlayPauseButton} hover-pop`}
					onClick={() => setIsAutoPlay(!isAutoPlay)}
					aria-label={isAutoPlay ? 'Pause carousel' : 'Play carousel'}
				>
					{isAutoPlay ? '⏸' : '▶'}
				</button>
			</div>
		</section>
	);
};

export default ProjectCarousel;